<!--error?.status == 100001-->
<div *ngIf="error?.status == 100001" class="vertical-center">
	<div class="text-center full-width">
		<div>
			<fa-icon icon="fa-exclamation-triangle" size="4x" class="text-danger"></fa-icon>
		</div>
		<p class="text-danger">{{ 'GENERIC.CONNECT_ERROR' | translate }}</p>
	</div>
</div>

<div *ngIf="loading">
	<div class="noshow loading">
		<mat-spinner color="accent"></mat-spinner>
	</div>
</div>

<div class=" vertical-center "  *ngIf="noAccount" >
	<div class="text-center w-100">
		<fa-icon icon="exclamation-triangle" size="2x" class="text-danger"></fa-icon>
		<div translate class="text-danger">GENERIC.NO_ACCOUNT</div>
	</div>
</div>

<div id="quick-guides-marker"></div>

<!-- mini-applications taskbar -->
<app-taskbar *ngIf="pluginManager?.appController?.show"></app-taskbar>


<div id="cursor-debug" *ngIf="measureHelper.showDebug">
	<table>
		<tr><td>{{ 'DEBUG.PICK_TIME' | translate }}</td><td>{{measureHelper.debugPickingTime}}</td></tr>
		<tr *ngFor="let d of measureHelper.debugProps | keyvalue"><td>{{d.key}}</td><td>{{d.value}}</td></tr>
		<tr *ngIf="measureHelper.showPickingMatrix"><td>{{ 'DEBUG.PICK_MATRIX' | translate }} ({{ measureHelper.pickedMatrix.length }})</td><td id="debug-picking-matrix">
			<table style="width:100%;">
				<tr>
					<th style="width:5%;">{{ 'DEBUG.IDX' | translate }}</th>
					<th style="width:12%;">{{ 'DEBUG.HEIGHT' | translate }}</th>
					<th style="width:12%;">{{ 'DEBUG.JUMP' | translate }}</th>
					<th style="width:20%;">{{ 'DEBUG.ABS' | translate }}</th>
					<th style="width:20%;">{{ 'DEBUG.MAX' | translate }}</th>
					<th style="width:30%;">{{ 'DEBUG.HEIGHTS' | translate }}</th>
				</tr>
				<tr *ngFor="let d of measureHelper.pickedMatrix">
					<td>{{d.idx}}</td>
					<td>{{d.height}}m</td>
					<td>{{d.jump}}m</td>
					<td>{{d.jumpabs}}m / {{d.jumpafter}}m</td>
					<td>{{d.max}} - {{d.test}} / {{d.inRange}}</td>
					<td>{{d.height1}}m {{d.height2}}m {{d.height3}}m </td>
				</tr>
			</table>
				<div class="matrix">
					<span *ngFor="let d of measureHelper.pickedMatrix" [class.fdm-selected]="d.height">{{ d.height }}</span>
				</div>
			</td>
		</tr>
		<tr *ngIf="measureHelper.debugLastThreePicks"><td>{{ 'DEBUG.LAST_THREE' | translate }}</td><td>{{ measureHelper.debugLastThreePicks }}</td>
	</tr>
	</table>
	picked=[{{ measureHelper.pickedCartesian }}] coord=[{{ measureHelper.pickedCoord }}]
</div>

<ng-container *ngIf="error?.status != 100001 && !loading && !noAccount">

	<mat-progress-bar color="accent" mode="indeterminate" class="progress-bar" [hidden]="!service.accLoading"></mat-progress-bar>

	<!-- Main Content Toolbar -->
	<mat-toolbar class="mat-elevation-z4 main-toolbar" *ngIf="fourD && fourD.activeUser">

		<div class="fdm-bread">
			<!-- logo image -->
			<img *ngIf="fourD.activeTeam" [routerLink]="[mainLink + '/projects']" vlink="image.png" [cache]="true"
				[model]="fourD.activeTeam" class="logo-image">
			<ng-container *ngIf="service.vasatInstance && !fourD.activeTeam">
			<img [routerLink]="[mainLink + '/projects']"
				src="{{service.V.config.host + '/' + service.vasatInstance.app_logo}}" class="logo-image">
			</ng-container>
			<ng-container *ngIf="!service.vasatInstance && !fourD.activeTeam">
				<img [routerLink]="[mainLink + '/projects']" class="icon" src="/assets/images/logo.png" class="logo-image">
			</ng-container>
		</div>

		<div class="fdm-bread" [style]="'margin-left:'+isMobile() ? 25 : 8 +'px'">
		
			<!-- Account menu icon -->
			<button id="guide-toolbar-account" class="fdm-top-menu-icon" mat-button style="margin-right:3px !important;" [matMenuTriggerFor]="accountMenu" *ngIf="permissions?.can?.see_menu_account?.toolbar">  
				<fa-icon icon="bars" [matTooltip]="fourD?.activeTeam?.name"></fa-icon>
			</button>
			
			<ng-container *ngIf="fourD?.teams?.length > 1">
				<span class="fdm-dropdown fdm-dropdown-inverse" [class.noshow]="isMobile() || isMobileLarge()" [matMenuTriggerFor]="t_select">
					<i>{{ fourD?.activeTeam?.name }} <mat-chip *ngIf="isNewTeams" selectable="False" color="accent" class="fdm-attention">{{ 'GENERIC.NEW' | translate }}</mat-chip></i> <fa-icon icon="angle-down"></fa-icon>
				</span>
				<!-- <i class="fdm-icon fdm-icon-projects float-right" mat-tooltip="Toggle favourite"
					(click)="toggleTeamFavourite();$event.stopPropagation();">
					<fa-icon [class.fdm-icon-selected]="fourD.activeTeam.props.isNew" icon="star"></fa-icon>
					</i> -->

				<span id="guide-toolbar-teams"></span>
				
				<mat-menu #t_select="matMenu" [overlapTrigger]="false">
					<button *ngFor="let cur of fourD.teams" mat-menu-item (click)="setTeam(cur)"> <!-- cur != fourD.activeTeam?setTeam(cur):null -->
						<span>{{ cur.name }} <fa-icon *ngIf="cur == fourD.activeTeam" icon="check"></fa-icon></span>
						<mat-chip *ngIf="cur.props.isNew" selectable="False" color="accent" class="fdm-attention">{{ 'GENERIC.NEW' | translate }}</mat-chip>
					</button>
				</mat-menu>
			</ng-container>
		
			<span style="margin-left:10px">

				<!-- Project tab / button -->
				<button mat-button class="fdm-main-toolbar-button" id="guide-toolbar-projects"
					*ngIf="fourD?.activeTeam?.active"
					[routerLink]="[mainLink + '/projects']"
					routerLinkActive="selected"
					[matTooltip]="'NAV.MENU_PROJECTS' | translate" >
					<fa-icon icon="project-diagram"></fa-icon>
					<span [class.noshow]="isMobile()"> {{'PROJECTS.LIST' | translate }}</span>
				</button>

				<!-- [{{ permissions?.can?.see_explorer?.toolbar }}] -->

				<!-- Data manager tab / button -->
				<ng-container *ngIf="permissions?.can?.see_explorer?.toolbar">
					<button mat-button class="fdm-main-toolbar-button" id="guide-toolbar-explorer"
						*ngIf="fourD?.activeTeam?.active && fourD?.activeTeam?.canWrite"
						[routerLink]="[mainLink + '/explorer']"
						routerLinkActive="selected"
						[matTooltip]="'NAV.MENU_EXPLORER' | translate" >
						<fa-icon icon="database"></fa-icon>
						<span [class.noshow]="isMobile()"> {{'NAV.MENU_EXPLORER' | translate }}</span>
					</button>
				</ng-container>

			</span>

			<span id="fdm-debug" class="noshow" style="color:#666;font-size:10px;"></span>
		</div>

		<div [class.noshow]="isMobile()" *ngIf="fourD?.activeUser['showLocation'] && isCurrentRouteProject()" style="position:absolute;left:50%;top:90px;padding:10px 15px;background-color:#00000088;border-radius:5px;">
			<div>
				<mat-slide-toggle color="primary"
				[(ngModel)]="fourD?.activeUser['showLocation']" (click)="saveProfileDelayed();toggleLocation();$event.stopPropagation()">
				<span style="font-size:12px;color:#fff;">{{ 'NAV.SHOW_LOCATION' | translate }}</span>
				</mat-slide-toggle>
				<fa-icon icon="paper-plane" class="fdm-linked float-right" style="padding:0 10px;" (click)="flyToLocation();"></fa-icon>
			</div>
			<div>
				<mat-slide-toggle color="primary"
				[(ngModel)]="fourD?.activeUser['useLocation']" (click)="saveProfileDelayed();toggleLocation();$event.stopPropagation()">
					<span style="font-size:12px;color:#fff;">{{ 'NAV.USE_LOCATION' | translate }}</span>
				</mat-slide-toggle>
			</div>
			<div class="fdm-linked" style="padding:0 4px;font-size:12px;" (click)="showPositionAdvanced = ! showPositionAdvanced;$event.stopPropagation()"> {{ 'NAV.ADVANCED' | translate }}
				<fa-icon *ngIf="!showPositionAdvanced" class="fdm-layer-icon" icon="chevron-down"></fa-icon>
				<fa-icon *ngIf="showPositionAdvanced" class="fdm-layer-icon" icon="chevron-up"></fa-icon>
			</div>
			<div [slide-down]="showPositionAdvanced">
				<div class="mini-info">
					<span class="mini-label">{{ 'NAV.POSITION.LAT' | translate }}</span> {{ mapService.geolocation.latitude }} 
				</div>
				<div class="mini-info">
					<span class="mini-label">{{ 'NAV.POSITION.LONG' | translate }}</span> {{ mapService.geolocation.longitude }}
				</div>
				<div class="mini-info">
					<span class="mini-label">{{ 'NAV.POSITION.HEIGHT' | translate }}</span> {{ mapService.geolocation.height | qmap_round }}m
				</div>
				<div class="mini-info">
					<span class="mini-label">{{ 'NAV.POSITION.SAMPLED' | translate }}</span> {{ mapService.geolocation.sampledHeight | qmap_round }}m
				</div>
				<div class="mini-info">
					<span class="mini-label">{{ 'NAV.POSITION.CAMERA' | translate }}</span>
					<input type="number" [(ngModel)]="mapService.geolocation.cameraHeight" (input)="mapService.setCameraHeight($event.srcElement.value)" [min]="1" [max]="8000" [step]="1" style="height:30px;margin:0 2px;">m
				</div>
			</div>
		</div>

		<div class="fdm-bread fdm-bread-full-center" [class.noshow]="isMobile()" *ngIf="permissions?.can?.see_upload?.toolbar">
			<div id="add-data-area" [class.fdm-drag-drop-zone-hover]="uploadButtonDragHover" 
			(drop)="mainService.dropFile($event);dragDropUploadButtonControl($event,false)" 
			(dragover)="dragDropUploadButtonControl($event,true)" 
			(dragenter)="dragDropUploadButtonControl($event,true)" 
			(dragleave)="dragDropUploadButtonControl($event,false)">
				<button id="add-data-button" mat-raised-button color="accent" class="fdm-force-color-accent fdm-button-upload" 
				(click)="openUploadGlobalDialog()">
					<fa-icon [icon]="['far','layer-plus']"></fa-icon> <div>{{'MAP.ADD_DATA' | translate }}</div>
				</button>
			</div>
			
		</div>

        <span class="spacer"></span>


		<!-- socket connection alerts -->
    	<span [class.noshow]="isMobile()" class="mr-3 ml-3 pr-2 pl-2" *ngIf="!fourD.socketUp" (click)="reconnect()">
			<fa-layers class="fa-fw fa-2x">
				<fa-icon [icon]="['fas', 'plug']" size="lg" transform="shrink-4"></fa-icon>
				<fa-icon [icon]="['fas','ban']" class="text-danger"></fa-icon>
			</fa-layers>
		</span>

		<!-- show progress bars -->
		<div [class.noshow]="isMobile()" id="guide-toolbar-progress" class="fdm-progress-section" *ngIf="permissions?.can?.see_progress?.toolbar && !service?.vasatInstance['disable_credits']">

			<button mat-button [matMenuTriggerFor]="credits">
				{{'MAP.CREDITS' | translate }} 
				<mat-chip color="default" [matMenuTriggerFor]="credits" style="color:#555;">
					<fa-icon icon="heart" style="color:#555;font-size:0.9em;"></fa-icon> 
					{{ (fourD.activeTeam?.autoCredit || 0) + (fourD.activeTeam?.adhocCredit || 0) | qmap_round }}
				</mat-chip> 
				<fa-icon icon="chevron-down" style="color:#bbb;margin-left:4px;font-size:12px;"></fa-icon>
			</button>
			<button mat-button [matMenuTriggerFor]="runningTasks" *ngIf="tasks.state | async as running">
				{{'MAP.STATUS' | translate }} 
				<mat-chip color="default" [matMenuTriggerFor]="runningTasks" style="color:#555;">
					{{ (running?.length || 0) + (fourD.uploadsRunning?.length || 0) }}
				</mat-chip>
				<fa-icon icon="chevron-down" style="color:#bbb;margin-left:4px;font-size:12px;"></fa-icon>
			</button>

		</div>

		<div class="fdm-bread align-right">
			<div id="debug-show-picking" *ngIf="fourD && fourD.activeUser && fourD.activeUser['showPickingTime']">
				<table>
					<tr><td>{{ 'DEBUG.PICK_TIME' | translate }}</td><td>{{measureHelper.debugPickingTime}}ms</td></tr>
					<ng-container *ngIf="sceneController">
						<tr><td>{{ 'DEBUG.TRANSPARENT_ITEMS' | translate }}</td><td>{{sceneController.anyTransparentItems}}</td></tr>
						<tr><td>{{ 'DEBUG.ANY_CLOUDS' | translate }}</td><td>{{sceneController.anyPointclouds}}</td></tr>
						<tr><td>{{ 'DEBUG.ANY_TERRAIN' | translate }}</td><td>{{sceneController.anyTerrain}}</td></tr>
						<tr><td>{{ 'DEBUG.TRANSPARENT_TERRAIN' | translate }}</td><td>{{sceneController.anyTransparentTerrain}}</td></tr>
					</ng-container>
				</table>
			</div>

			<!-- Help icon -->
			<!-- <button class="fdm-top-menu-icon" mat-button target="_blank" (click)="openURL('https://4dmapper.com/help/')">
				<fa-icon icon="question-circle" matTooltip="{{ 'NAV.MENU_HELP' | translate }}"></fa-icon>
			</button> -->

			<!-- New help menu -->
			<button id="guide-toolbar-help" *ngIf="permissions?.can?.see_help?.toolbar" [class.noshow]="isMobile()" class="fdm-top-menu-icon" [matMenuTriggerFor]="menu" mat-button matTooltip="{{ 'NAV.MENU_HELP' | translate }}" >
				<fa-icon icon="question-circle"></fa-icon>
			</button>
			
			<mat-menu #menu="matMenu" [overlapTrigger]="false">
				<div class="fdm-menu-info">	
					<h3>{{ 'NAV.MENU_HELP' | translate }}</h3>	
				</div>
				
				<!-- <button mat-menu-item>
					<a target="_new" href="{{ 'API.API_LINK' | translate }}"><fa-icon icon="external-link-alt"></fa-icon> {{ 'API.API_LINK_TEXT' | translate }}</a>
				</button> -->

				<!-- Help and tutorials -->
				<button mat-menu-item>
					<a class="fdm-linked" target="_new" href="{{ 'NAV.HELP_LINK' | translate }}"><fa-icon icon="external-link-alt"></fa-icon> {{ 'NAV.HELP_LINK_TEXT' | translate }}</a>
				</button>	
				
				<!-- FAQs -->	
				<button mat-menu-item>
					<a class="fdm-linked" target="_new" href="{{ 'NAV.FAQS_LINK' | translate }}" ><fa-icon icon="external-link-alt"></fa-icon> {{ 'NAV.FAQS_LINK_TEXT' | translate }}</a>
				</button>

				<!-- Quick guides -->
				<button mat-menu-item>
				<span (click)="showQuickGuides()" class="fdm-linked"><fa-icon icon="question-circle"></fa-icon> {{ 'NAV.QUICK_GUIDES' | translate }}</span>
				</button>

				<!-- Supported formats -->	
				<button mat-menu-item>
					<a class="fdm-linked" target="_new" href="{{ 'NAV.SUPPORTED_FORMATS_LINK' | translate }}" ><fa-icon icon="external-link-alt"></fa-icon> {{ 'NAV.SUPPORTED_FORMATS_LINK_TEXT' | translate }}</a>
				</button>
				
				<!-- What's new -->	
				<button mat-menu-item>
					<a class="fdm-linked" target="_new" href="{{ 'NAV.WHATS_NEW_LINK' | translate }}" ><fa-icon icon="external-link-alt"></fa-icon> {{ 'NAV.WHATS_NEW_LINK_TEXT' | translate }}</a>
				</button>

				<!-- Contact us -->
				<ng-container *ngIf="service.showContactUs()">
					<hr/>
					<ng-container *ngIf="!contactUsShow">
						<button mat-menu-item>
							<span (click)="clickContactUs();$event.stopPropagation()" class="fdm-linked"><fa-icon icon="info"></fa-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.LABEL' | translate }}</span>
						</button>
					</ng-container>

					<div style="padding:0 10px 10px 10px" *ngIf="contactUsShow && contactUsRequest">
						<ng-container *ngIf="contactUsState=='ready'">
							<!-- <input *ngFor="let n of ['NAME','EMAIL','USER_ID','ACCOUNT_ID']" type="hidden" [name]="n" [value]="autoFill(n)" /> -->
							
							<h6>
								{{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.MESSAGE' | translate }}
								<span (click)="clickContactUsDone();$event.stopPropagation()" class="fdm-linked float-right"><fa-icon icon="chevron-up"></fa-icon></span>
							</h6>
							<textarea [(ngModel)]="contactUsMessage" style="width:100%;font-size:12px;height:200px;color:#999;padding:5px;" (click)="$event.stopPropagation()"></textarea>
							<button mat-menu-item *ngIf="contactUsState=='ready' && contactUsMessage !== ''" (click)="clickContactUsSend();$event.stopPropagation()">
								<span class="fdm-linked"><fa-icon icon="arrow-right"></fa-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SEND' | translate }}</span>
							</button>
						</ng-container>

						<ng-container *ngIf="contactUsState=='sent' || contactUsState=='error'">
							<div *ngIf="contactUsState=='sent'" class="alert">{{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SENT' | translate }}</div>
							<div *ngIf="contactUsState=='error'" class="alert alert-danger">{{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.SENT_ERROR' | translate }}</div>
							<button mat-menu-item>
								<span (click)="clickContactUsDone();$event.stopPropagation()" class="fdm-linked"><fa-icon icon="chevron-up"></fa-icon> {{ 'MAP.GUIDES_DASHBOARD.CONTACT_US.GO_BACK' | translate }} </span>
							</button>
						</ng-container>
						
						<mat-progress-bar color="accent" *ngIf="contactUsState=='sending'" class="mt-1" mode="indeterminate"></mat-progress-bar>
						
					</div>
				</ng-container>
				
			</mat-menu>

			<!-- Quick settings button -->
			<button id="guide-toolbar-settings" class="fdm-top-menu-icon" mat-button matTooltip="{{ 'NAV.MENU_SETTING' | translate }}" [matMenuTriggerFor]="c_select">
				<fa-icon icon="cog"></fa-icon>
			</button>
			<mat-menu #c_select="matMenu" [overlapTrigger]="false">
				<div style="background-color:#fff;padding:20px;" *ngIf="fourD && fourD.activeUser">

					<!-- General settings -->
					<div class="fdm-linked" style="margin-top:10px;">
						<div style="padding:0 4px;font-size:12px; margin:15px 3px;"> {{ 'NAV.GENERAL' | translate }}</div>
					</div>

					<!-- Simple mode -->
					<div>
						<mat-slide-toggle color="primary" [(ngModel)]="uiManager.uiModeSwitch" (click)="uiManager.toggleMode();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'NAV.SIMPLE_MODE' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div *ngIf="uiManager.uiModeSwitch" style="margin-left:20px;">
						<mat-slide-toggle color="primary" [(ngModel)]="uiManager.uiModeHideSimple" (click)="$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'NAV.HIDE_UNAVAILABLES' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showCoordinates']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.SHOW_COORDINATES' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showCameraCoordinates']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.SHOW_CAMERA_COORDINATES' | translate }}</span>
						</mat-slide-toggle>
					</div>

					<div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showHoverPopups']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.MOUSE_HOVER' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div *ngIf="fourD?.activeUser['showHoverPopups']" style="margin-left:20px;">
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showHoverPopupsImageFeatures']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.MOUSE_HOVER_IMAGE_FEATURES' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div *ngIf="fourD?.activeUser['showHoverPopups']" style="margin-left:20px;">
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showHoverPopupsImageLayers']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.MOUSE_HOVER_IMAGE_LAYERS' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showLocation']" (click)="saveProfileDelayed();toggleLocation();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.SHOW_LOCATION' | translate }}</span>
						</mat-slide-toggle>
						<fa-icon icon="paper-plane" class="fdm-linked float-right" (click)="flyToLocation();"></fa-icon>
					</div>
					<div  *ngIf="fourD?.activeUser['showLocation']" style="margin-left:20px;">
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['useLocation']" (click)="saveProfileDelayed();toggleLocation();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'NAV.USE_LOCATION' | translate }}</span>
						</mat-slide-toggle>
					</div>
					<!-- <div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showNavigationToolbar']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.SHOW_TOOLBAR' | translate }}</span>
						</mat-slide-toggle>
					</div> -->
					<div>
						<mat-slide-toggle color="primary"
						[(ngModel)]="fourD?.activeUser['showNavigator']" (click)="saveProfileDelayed();$event.stopPropagation()">
						<span style="font-size:12px;color:#888;">{{ 'NAV.SHOW_CONTROLS' | translate }}</span>
						</mat-slide-toggle>
					</div>
					
				<!--	<div>
						<mat-slide-toggle color="primary" [(ngModel)]="fourD?.activeUser['showContextMenu']"  (click)="saveProfileDelayed();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'MAP.CONTEXT_MENU' | translate }}</span>
						</mat-slide-toggle>
					</div> -->
					<!-- <div *ngIf="fourD?.activeUser['showContextMenu']" style="margin-left:20px;">
						<mat-slide-toggle color="primary" [(ngModel)]="fourD.activeUser['showContextMenuFloating']" (click)="saveProfileDelayed();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'MAP.FLOATING' | translate }}</span>
						</mat-slide-toggle>
					</div> -->


					<div class="fdm-linked" style="margin-top:10px;" (click)="showAdvanced = ! showAdvanced;$event.stopPropagation()">
						<div style="padding:0 4px;font-size:12px;"> {{ 'NAV.ADVANCED' | translate }}
							<fa-icon *ngIf="!showAdvanced" class="fdm-layer-icon" icon="chevron-down"></fa-icon>
							<fa-icon *ngIf="showAdvanced" class="fdm-layer-icon" icon="chevron-up"></fa-icon>
						</div>
					</div>
					<div [slide-down]="showAdvanced">
						<div style="color:#888;font-size:12px;margin:15px 3px;" (click)="$event.stopPropagation()">
							<div style="margin-bottom:2px;padding-bottom:2px;border-bottom:solid 1px #d4d4d4;">{{ 'NAV.ADDITIONAL_ACCESS' | translate }}</div>
							<div>
								<div class="fdm-checkboxes">
									<input id="pc-advanced" class="fdm-checkbox fdm-linked" type="checkbox"
										[(ngModel)]="fourD?.activeUser['showPluginsAdvanced']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-advanced"></label> {{ 'PLUGINS.CATEGORY.ADVANCED' | translate }}
								</div>
								<div class="fdm-checkboxes">
									<input id="pc-beta" class="fdm-checkbox fdm-linked" type="checkbox"
										[(ngModel)]="fourD?.activeUser['showPluginsBeta']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-beta"></label> {{ 'PLUGINS.CATEGORY.BETA' | translate }}
								</div>
								<div class="fdm-checkboxes" style="color:rgb(63, 122, 180)">
									<input id="pc-debug" class="fdm-checkbox fdm-linked" type="checkbox" 
										[(ngModel)]="fourD?.activeUser['showPluginsDebug']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-debug"></label> {{ 'PLUGINS.CATEGORY.DEBUG' | translate }}
								</div>
								<div class="fdm-checkboxes" style="color:rgb(206, 138, 53)">
									<input id="pc-deprecated" class="fdm-checkbox fdm-linked" type="checkbox" 
										[(ngModel)]="fourD?.activeUser['showPluginsDeprecated']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-deprecated"></label> {{ 'PLUGINS.CATEGORY.DEPRECATED' | translate }}
								</div>
								<div class="fdm-checkboxes" style="color:rgb(206, 138, 53)">
									<input id="pc-experimental" class="fdm-checkbox fdm-linked" type="checkbox"
										[(ngModel)]="fourD?.activeUser['showPluginsExperimental']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-experimental"></label> {{ 'PLUGINS.CATEGORY.EXPERIMENTAL' | translate }}
								</div>
								<div class="fdm-checkboxes" style="color:rgb(63, 122, 180)">
									<input id="pc-technical" class="fdm-checkbox fdm-linked" type="checkbox"
										[(ngModel)]="fourD?.activeUser['showPluginsTechnical']" (click)="saveProfileDelayed();updatePluginManager();$event.stopPropagation()" />
									<label for="pc-technical"></label> {{ 'PLUGINS.CATEGORY.TECHNICAL' | translate }}
								</div>
							</div>
						</div>
						
						<div>
							<div style="color:#888;font-size:12px;" (click)="$event.stopPropagation()">
							<div style="margin-bottom:2px;padding-bottom:2px;border-bottom:solid 1px #d4d4d4;">{{ 'NAV.DEBUG' | translate }}</div>
							</div>
							<mat-slide-toggle color="primary"
							[(ngModel)]="fourD?.activeUser['showFPS']" (click)="saveProfileDelayed();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'NAV.FPS' | translate }}</span>
							</mat-slide-toggle>
						</div>
						<div>
							<mat-slide-toggle color="primary"
							[(ngModel)]="fourD?.activeUser['showPickingTime']" (click)="saveProfileDelayed();$event.stopPropagation()">
							<span style="font-size:12px;color:#888;">{{ 'NAV.PICKTIME' | translate }}</span>
							</mat-slide-toggle>
						</div>

						<div>
							<button style="font-size:13px!important;height:22px;margin:15px 3px" color="primary" mat-raised-button class="fdm-button" (click)="toggleCesiumDebugger()">{{ 'NAV.DEBUGGER' | translate }}</button>
						</div>

						<div>
							<button style="font-size:13px!important;height:22px;margin:15px 3px" color="primary" mat-raised-button class="fdm-button" (click)="sceneController.sendReport()">{{ 'NAV.DEBUGGER_REPORT' | translate }}</button>
						</div>

					</div>

				</div>
			</mat-menu>

			<!-- Profile menu icon -->
			<button id="guide-toolbar-user" class="fdm-top-menu-icon" mat-button [matMenuTriggerFor]="settingsMenu">
				<img class="icon-sml fdm-img-circle" vlink="image.png" [model]="fourD.activeUser" matTooltip="{{ 'NAV.MENU_PROFILES' | translate }}" />
				<span class="noshow">{{ fourD.activeUser?.name }} </span>
				<!-- <textarea style="height:400px;position:absolute;font-size:10px;left:-300px;top:100px;width:300px;">{{ fourD.activeUser | json }}</textarea> -->
			</button>

			


		</div>

	</mat-toolbar>

	<!-- Main Content -->
	<div class="main-content">
		<router-outlet></router-outlet>
	</div>

	


	<!-- Current credits -->
	<mat-menu #credits="matMenu" [overlapTrigger]="false">
		<div class="fdm-menu-info">
			<h3>{{'MAP.CREDITS' | translate }}</h3>
			<li><b><fa-icon icon="heart" style="color:#555;font-size:0.9em;"></fa-icon> {{ ( fourD?.activeTeam?.autoCredit || 0 ) | qmap_round }}</b> {{'MAP.CREDITS_PLAN' | translate }}</li>
			<li><b><fa-icon icon="heart" style="color:#555;font-size:0.9em;"></fa-icon> {{ ( fourD?.activeTeam?.adhocCredit || 0 ) | qmap_round }}</b> {{'MAP.CREDITS_PURCHASED' | translate }} </li>
		</div>

		<div style="text-align:center;padding:25px 8px;">
			<button *ngIf="fourD?.activeTeam?.canWrite" mat-raised-button color="primary" class="fdm-button-small" (click)="navigateToRoute(routes.MAIN + '/admin/plan')" >
				{{'MAP.BUY_CREDITS' | translate }} <fa-icon icon="credit-card"></fa-icon>
			</button>
		</div>
		

	</mat-menu>


		<!-- Jobs messages -->

      <mat-menu #runningTasks="matMenu" [overlapTrigger]="false">
		<ng-container *ngIf="tasks.state | async as runningTasks">

			<div class="fdm-menu-info">
				<h6>{{'MAP.STATUS' | translate }}</h6>
				<li><fa-icon icon="briefcase"></fa-icon>&nbsp;<b>{{ runningTasks?.length }}</b> {{'MAP.JOBS_RUNNING' | translate }}</li>
				<li><fa-icon icon="file-image"></fa-icon>&nbsp;<b>{{ fourD.uploadsRunning?.length }}</b> {{'MAP.FILES_UPLOADING' | translate }}</li>
			</div>

			<!-- <p style="padding-left:5px;color:#777;"><fa-icon icon="briefcase"></fa-icon>&nbsp;<b>{{ fourD.runningTasks?.length }}</b> {{'MAP.JOBS_RUNNING' | translate }}</p> -->
			<div mat-menu-item *ngFor="let task of runningTasks">
			<div>{{ task.task.dataset?.name || task.task.dataset?.id }}</div>
			<div class="processing">
				<i [class]="task.status" translate>{{ 'PROCESSING.' + task.task.name }}</i>
			</div>
			</div>

			<mat-divider></mat-divider>

			<div mat-menu-item *ngFor="let task of fourD.uploadsRunning">
				<div>{{ task.dataset?.name || task.dataset?.id }}</div>
				<div class="processing">
					<i [class]="task.status" translate>{{ 'PROCESSING.' + task.name }}</i>
				</div>
			</div>

			<div mat-menu-item *ngIf="fourD.uploadsQueued.length">
				{{ 'NAV.ULQUEUE' | translate: {items:fourD.uploadsQueued.length} }}
			</div>

		</ng-container>
    </mat-menu>



    <!-- Account menu -->
	
    <mat-menu #accountMenu="matMenu" [overlapTrigger]="false">

    	<div class="fdm-menu-info" *ngIf="fourD?.activeTeam && fourD?.activeTeam?.plan">
			<h3>{{ fourD.activeTeam?.name }}</h3>
			<li><fa-icon icon="clock"></fa-icon> &nbsp;{{ 'GENERIC.CREATED' | translate }} <b>{{ fourD.activeTeam.dateMade | dateAgo | async }}</b> </li>
			<ng-container *ngIf="teamStats && fourD?.activeTeam?.plan">
				<li><fa-icon icon="user"></fa-icon> 
					&nbsp;{{ 'MAP.USAGE.USING' | translate }} <b>{{ teamStats?.users }}</b> {{'MAP.USAGE.OF' | translate }} 
					{{ fourD.activeTeam.plan.maxUsersBase }} {{'MAP.USAGE.USERS' | translate }}
				</li>
				<li><fa-icon icon="project-diagram"></fa-icon>
					&nbsp;{{ 'MAP.USAGE.USING' | translate }} <b>{{ teamStats?.projects }}</b> {{'MAP.USAGE.OF' | translate }} 
					{{ fourD.activeTeam.plan.maxProjectsBase }} {{'ENTITY.PROJ' | translate }}
				</li>
				<li><fa-icon icon="database"></fa-icon>
					&nbsp;{{ 'MAP.USAGE.USING' | translate }} <b>{{ 100*(teamStats?.quota / fourD.activeTeam.plan.maxStorageBase) | qmap_round }}</b> {{'MAP.USAGE.OF' | translate }} 
					{{ fourD.activeTeam.plan.maxStorageBase / 1000000000 | qmap_round }} GB {{ 'ENTITY.STORE' | translate }} 
				</li>
				<li *ngIf="fourD.activeTeam.plan.isTrial">
					<fa-icon icon="receipt"></fa-icon> &nbsp;{{'MAP.TRIAL_PLAN' | translate }} <br/><br/>
					<button mat-raised-button color="primary" class="fdm-button-small" (click)="navigateToRoute(routes.MAIN + '/admin/plan')" >
						{{'MAP.UPGRADE' | translate }} <fa-icon icon="level-up"></fa-icon>
					</button>
				</li>
				<li *ngIf=" ! fourD.activeTeam.plan.isTrial">
					<fa-icon icon="receipt"></fa-icon> &nbsp;{{'MAP.USAGE.YOU_ARE' | translate }} {{ fourD.activeTeam.plan.name }} {{'MAP.USAGE.PLAN' | translate }}
				</li>	
			</ng-container>
			
			<li> <fa-icon icon="code-branch"></fa-icon> &nbsp;v. {{ service?.vasatInstance?.app_version }}</li>		
        </div>

		<mat-divider></mat-divider>

		<!-- Create new account -->
        <button *ngIf="permissions?.can?.create?.account" mat-menu-item (click)="addAccount()">
			<mat-icon>add</mat-icon>
			<span>{{ 'NAV.MENU_ACCOUNT_ADD' | translate }}</span>
        </button>

		<!-- Switch organization 
        <mat-divider  *ngIf="permissions?.can?.create?.account"></mat-divider>
        <button mat-menu-item *ngIf="fourD?.teams?.length > 0"  [matMenuTriggerFor]="teamsPicker">
			<mat-icon><fa-icon icon="exchange-alt"></fa-icon></mat-icon>
			<span >{{'NAV.MANAGE_GROUPS' | translate }}</span>
        </button> -->

		<!-- Account details -->
        <ng-container  *ngIf="fourD.activeTeam?.canWrite">
          <button mat-menu-item (click)="navigateToRoute(routes.MAIN + '/' +  routes.ADMIN_ACCOUNT)">
            <mat-icon>business</mat-icon>
            <span>{{'NAV.MENU_ACCOUNT_ADMIN' | translate }}</span>
          </button>

          <button mat-menu-item (click)="navigateToRoute(routes.MAIN + '/admin/plan')">
            <mat-icon><fa-icon [icon]="['far','credit-card']"></fa-icon></mat-icon>
            <span>{{'NAV.MENU_ACCOUNT_PLAN' | translate }}</span>
          </button>

          <mat-divider></mat-divider>

          <button mat-menu-item [disabled]="!fourD.activeTeam?.active" (click)="navigateToRoute(routes.MAIN + '/' +  routes.ADMIN_USERS)">
            <mat-icon>group</mat-icon>
            <span>{{'NAV.MANAGE_USERS' | translate }}</span>
          </button>

          <button mat-menu-item [disabled]="!fourD?.activeTeam?.active" (click)="navigateToRoute(routes.MAIN + '/' +  routes.ADMIN_APIS    )">
            <mat-icon>settings_input_component</mat-icon>
            <span>{{'NAV.MENU_API' | translate }}</span>
          </button>
         </ng-container>
      </mat-menu>

      <mat-menu #teamsPicker="matMenu" [overlapTrigger]="false">
         <button *ngFor="let cur of fourD.teams" mat-menu-item (click)="cur != fourD.activeTeam?setTeam(cur):null">
          <span>{{ cur.name }} <fa-icon *ngIf="cur == fourD.activeTeam" icon="check"></fa-icon></span>
        </button>
      </mat-menu>

      <!-- Profile menu -->

      <mat-menu class="fdm-top-menu-pane" #settingsMenu="matMenu" [overlapTrigger]="false" xPosition="before">

		<div class="fdm-menu-info">
			<h6>{{ 'NAV.MENU_USER' | translate }}</h6>
			<li><fa-icon icon="user"></fa-icon> &nbsp;<b>{{ fourD.activeUser?.name }}</b></li>
			<li><fa-icon icon="address-book"></fa-icon> &nbsp;<b>{{ fourD.activeUser?.username }}</b></li>
			<li><fa-icon icon="clock"></fa-icon> &nbsp;{{'MAP.LISTS.CREATED' | translate }} <b>{{ fourD.activeUser?.dateMade | dateAgo | async }}</b> </li>
		</div>

        <button mat-menu-item (click)="navigateToRoute(routes.MAIN_PROFILE)">
          <mat-icon>account_circle</mat-icon>
          <span>{{'NAV.MENU_PROFILE' | translate }}</span>
		</button>
		
		<mat-divider></mat-divider>
		
        <button mat-menu-item [matMenuTriggerFor]="langMenu">
          <mat-icon>language</mat-icon>
          <span>{{'NAV.MENU_LANG' | translate }}</span>
        </button>

		<mat-divider></mat-divider>
		
        <button mat-menu-item (click)="logout()">
			<mat-icon>power_settings_new</mat-icon>
			<span>{{'NAV.MENU_LOGOUT' | translate }}</span>
        </button>
    </mat-menu>

    <!-- Languages menu -->
    <mat-menu #langMenu="matMenu">
        <button mat-menu-item *ngFor="let lang of service.languages" (click)="translate.use(lang.code);service.siteSettings['language'] = lang.code;">{{lang.name}}
        </button>
	</mat-menu>
	
    <!-- Themes menu -->
    <mat-menu #themeMenu="matMenu">
    	<button mat-menu-item *ngFor="let theme of service.themes" (click)="service.curThemeClass=theme.class">
			{{theme.name | translate }}
        </button>
    </mat-menu>

</ng-container>
